import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/* function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
 */

let isEnabled = true;

export const useUserStore = create(
  persist(
    (set) => ({
      userScopes: [],
      userRoles: [],
      firstAvailableLink: null,
      screeningAvailable: false,
      isAgency: false,
      isClient: false,
      isInterviewer: false,
      isAdmin: false,
      companyId: null,

      setUserScopes: (scopes) => set({ userScopes: scopes }),
      setUserRoles: (roles) => set({ userRoles: roles }),
      setFirstAvailableLink: (link) => set({ firstAvailableLink: link }),
      setScreeningAvailable: (available) =>
        set({ screeningAvailable: available }),
      setIsAgency: (isAgency) => set({ isAgency }),
      setIsClient: (isClient) => set({ isClient }),
      setIsInterviewer: (isInterviewer) => set({ isInterviewer }),
      setIsAdmin: (isAdmin) => set({ isAdmin }),
      setCompanyId: (companyId) => set({ companyId }),
    }),
    {
      name: 'userStorage',
    }
  )
);

export const useFeedStore = create((set) => ({
  sharedClasses: '',
  editingPostRef: null,
  lastTextBoxRange: null,
  quoteContainers: [],
  refetchPosts: () => {},
  hasFechedPosts: false,
  unreadPostCount: 0,

  setEditingPostRef: (ref) => set({ editingPostRef: ref }),
  setLastTextBoxRange: (range) => set({ lastTextBoxRange: range }),
  setSharedClasses: (classes) => set({ sharedClasses: classes }),
  setQuoteContainers: (containers) => set({ quoteContainers: containers }),
  addQuoteContainer: (container) =>
    set((state) => ({
      quoteContainers: [...state.quoteContainers, container],
    })),
  setRefetchPosts: (refetch) => set({ refetchPosts: refetch }),
  setHasFechedPosts: (hasFeched) => set({ hasFechedPosts: hasFeched }),
  resetUnreadPostCount: () => set({ unreadPostCount: 0 }),
  increaseUnreadPostCount: () =>
    set((state) => ({ unreadPostCount: state.unreadPostCount + 1 })),
}));

export const usePersistedFeedStore = create(
  persist(
    (set) => ({
      lastVisibleFeedPostId: null,

      setLastVisibleFeedPostId: (id) => set({ lastVisibleFeedPostId: id }),
    }),
    {
      name: 'persistedFeedStorage',
    }
  )
);

export const useMapStore = create((set) => ({
  lastLocation: null,
  selectedMarker: '',
  isSidebarVisible: false,
  isDarkMode: false,
  zoom: 10,
  isOnlyFavoritesMode: false,

  setLastLocation: (location) => set({ lastLocation: location }),
  setInitialLocation: (location) => set({ initialLocation: location }),
  // eslint-disable-next-line no-shadow
  setIsZoomEnabled: (isEnabled) => set({ isZoomEnabled: isEnabled }),
  setCurrentPosition: (position) => set({ currentPosition: position }),
  setSelectedMarker: (marker) => set({ selectedMarker: marker }),
  setIsSidebarVisible: (isVisible) => set({ isSidebarVisible: isVisible }),
  setIsDarkMode: (isDarkMode) => set({ isDarkMode }),
  setZoom: (zoom) => set({ zoom }),

  increaseZoom: () =>
    set((state) => {
      if (state.zoom < 21) {
        return { zoom: state.zoom + 1 };
      }
      return { zoom: 21 };
    }),

  decreaseZoom: () =>
    set((state) => {
      if (state.zoom > 1) {
        return { zoom: state.zoom - 1 };
      }
      return { zoom: 1 };
    }),

  setIsOnlyFavoritesMode: (isOnlyFavoritesMode) => set({ isOnlyFavoritesMode }),

  toggleDarkMode: () => set((state) => ({ isDarkMode: !state.isDarkMode })),
  toggleOnlyFavoritesMode: () =>
    set((state) => ({ isOnlyFavoritesMode: !state.isOnlyFavoritesMode })),

  resetMapStore: () =>
    set({
      isZoomEnabled: true,
      lastLocation: null,
      selectedMarker: '',
      isSidebarVisible: false,
      isDarkMode: false,
      zoom: 10,
      isOnlyFavoritesMode: false,
    }),
}));

export const useUiStore = create((set) => ({
  isMobileSidebarVisible: false,
  isAddCandidatePopupVisible: false,
  isAddCandidateEditMode: false,
  editAssessmentInitialScreen: 'assessment',

  openMobileSidebar: () => {
    return set({ isMobileSidebarVisible: true });
  },
  // Debounce is required because mobile drag and drop polyfill (https://bernardo-castilho.github.io/DragDropTouch/DragDropTouch.js) causes double click on sidebar activation
  toggleMobileSidebar: () => {
    return set((state) => {
      if (isEnabled) {
        isEnabled = false;
        setTimeout(() => {
          isEnabled = true;
        }, 500);
      } else {
        return {
          isMobileSidebarVisible: state.isMobileSidebarVisible,
        };
      }

      return {
        isMobileSidebarVisible: !state.isMobileSidebarVisible,
      };
    });
  },
  toggleAddCandidatePopup: () =>
    set((state) => ({
      isAddCandidatePopupVisible: !state.isAddCandidatePopupVisible,
    })),
  setIsAddCandidateEditMode: (isEditMode) =>
    set({ isAddCandidateEditMode: isEditMode }),

  setEditAssessmentInitialScreen: (screen) =>
    set({ editAssessmentInitialScreen: screen }),
}));

export const useJobsStore = create((set) => ({
  selectedCompanyForMyJobs: null,
  setSelectedCompanyForMyJobs: (company) =>
    set({ selectedCompanyForMyJobs: company }),
}));
